import request from '@/utils/request';
/* 列表 */
export function queryActiveGoodsPageList(data) {
  return request({
    url: '/active/goods/queryActiveGoodsPageList',
    method: 'POST',
    data
  });
}
/* 增加 */
export function saveActiveGoods(data) {
  return request({
    url: '/active/goods/saveActiveGoods',
    method: 'POST',
    data
  });
}
/* 修改 */
export function updateActiveGoods(data) {
  return request({
    url: '/active/goods/updateActiveGoods',
    method: 'POST',
    data
  });
}
/* 修改中的信息展示 */
export function fetchActiveGoodsDetailById(data) {
  return request({
    url: '/active/goods/fetchActiveGoodsDetailById',
    method: 'POST',
    data
  });
}
/* 删除 */
export function removeActiveGoodsById(data) {
  return request({
    url: '/active/goods/removeActiveGoodsById',
    method: 'POST',
    data
  });
}
/* 查询所有上架的商品列表 */
export function queryAllEnableGoodsList(data) {
  return request({
    url: '/active/goods/queryAllEnableGoodsList',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/activity.js